import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    standalone: false,
    name: 'age',
    
})
export class AgePipe implements PipeTransform {

  transform(birthDate: string): string {
    const now = moment();
    const birthMoment = moment(new Date(birthDate));

    if(!birthMoment.isValid() || !birthDate) return '';       
    
    const years = now.diff(birthMoment, 'years');
    if (years > 0) {
      return years === 1 ? `${years} year` : `${years} years`;
    }

    const months = now.diff(birthMoment, 'months');
    if (months > 0) {
      return months === 1 ? `${months} month` : `${months} months`;
    }

    const days = now.diff(birthMoment, 'days');
    return days === 1 ? `${days} day` : `${days} days`;
  }

}
